import { render } from "./TwilioWorkingHoursGreetingEditor.vue?vue&type=template&id=9abab5cc"
import script from "./TwilioWorkingHoursGreetingEditor.vue?vue&type=script&lang=js"
export * from "./TwilioWorkingHoursGreetingEditor.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__